import "./CleaningDetail.module.css";
import Header from "@/reusable_sections/Header";
import VerfahrenTechnik from "./sections/VerfahrenTechnik";
import VorteileSysteme from "./sections/VorteileSysteme";
import Footer from "@/reusable_sections/Footer";
export default function CleaningDetailPage() {
  return <div>
      <Header />
      <VerfahrenTechnik />
      <VorteileSysteme />
      <Footer />
    </div>;
}